import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, InfoCard } from 'app/components';
import { Sparkle, X } from '@phosphor-icons/react';
import  EventCard  from './eventCard';
import './style';

const PublishEventModal = ({ isOpen, onClose, onConfirm, eventData }) => {
  const [loading, setLoading] = useState(true);
  const { activeRequests } = useSelector((state) => state.app);

  useEffect(() => {
    if (activeRequests?.includes('create-event') || activeRequests?.includes('save-event')) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [activeRequests]);

  return (
    <div>
      <Modal
        isOpen={isOpen}
        size="regular"
        className="publish-modal"
        title={(<div className="heading-24 flex w-full justify-between">
          Publish your event!
          <div className="border border-grey-30 rounded-full bg-grey-30 p-2">
            <X size="16"
              onClick={onClose} />
          </div>
        </div>)}
      >
        <div className=" flex flex-col justify-center items-center gap-4">
          <div className=" flex flex-col justify-center items-center gap-2">
            <EventCard
              eventName={eventData.name}
              eventCity={eventData.geo_location}
              eventType={eventData.type}
              eventDate={eventData.start_date}
              endDate={eventData?.end_date}
              url={eventData?.full_image || eventData?.image}
            />
            <InfoCard
              icon={<Sparkle weight="fill"
                size={24} />}
              content={'You can edit the details until the event goes live. '}
            />
          </div>
          <Button
            type="primary-black"
            className="w-full"
            children={'Confirm'}
            loading={loading}
            disabled={loading}
            onClick={onConfirm}
          />
        </div>
      </Modal>
    </div>
  );
};

export default PublishEventModal;
